import htmlToDom from '../../../../helpers/htmlToDom';
import makeTimeEl from './makeTimeEl';

export default (times) => {
	const morningPeriodStart = 9;
	const dayPeriodStart = 12;
	const eveningPeriodStart = 18;
	const morningPeriodEnd = dayPeriodStart - 1;
	const dayPeriodEnd = eveningPeriodStart - 1;
	const eveningPeriodEnd = 24;

	const isHourInPeriod = (hour, start, end) => {
		const hoursOfPeriod = Array.from(
			{ length: end - start + 1 },
			(_, idx) => start + idx
		);
		return hoursOfPeriod.includes(hour);
	};

	const getTimeOfPeriod = (start, end, allTimes) =>
		allTimes.data.filter(({ time }) => {
			const hour = parseInt(time.split(':')[0], 10);
			return isHourInPeriod(hour, start, end);
		});

	const morningTimes = getTimeOfPeriod(
		morningPeriodStart,
		morningPeriodEnd,
		times
	);
	const dayTimes = getTimeOfPeriod(dayPeriodStart, dayPeriodEnd, times);
	const eveningTimes = getTimeOfPeriod(
		eveningPeriodStart,
		eveningPeriodEnd,
		times
	);
	const allTimes = getTimeOfPeriod(morningPeriodStart, eveningPeriodEnd, times);

	const makePeriod = (name, periodTimes) =>
		[
			htmlToDom(`<h4 class="modal__time-header">${name}</h4>`),
			htmlToDom(`
			<ul class="modal__time-list">
				${periodTimes.map(makeTimeEl).join('')}
			</ul>
		`),
		].join('');

	if (document.documentElement.clientWidth < 786) {
		return htmlToDom(`
		<div class="modal__time-wrapper">
			${makePeriod('Весь день', allTimes)}
			<div class="modal__time--chosen" data-rm-selected-datetime-info></div>
			<ul class="modal__time-list-state">
				<li class="modal__time-item-state">Занято</li>
				<li class="modal__time-item-state">Свободно</li>
				<li class="modal__time-item-state">Выбрано</li>
			</ul>
		</div>
	`);
	} else {
		return htmlToDom(`
		<div class="modal__time-wrapper">
			${makePeriod('Утро', morningTimes)}
			${makePeriod('День', dayTimes)}
			${makePeriod('Вечер', eveningTimes)}
			<div class="modal__time--chosen" data-rm-selected-datetime-info></div>
			<ul class="modal__time-list-state">
				<li class="modal__time-item-state">Занято</li>
				<li class="modal__time-item-state">Свободно</li>
				<li class="modal__time-item-state">Выбрано</li>
			</ul>
		</div>
	`);
	}
};
